import React from 'react';
import { unescapeHTML } from 'underscore.string';
import { Translation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import DropdownItem from '../v2/dropdowns/DropdownItem';
import Badge from '../v2/Badge';
const roleStyles = {
    Shipper: 'brand',
    Carrier: 'blue',
    Driver: 'blue',
    Unauthorized: 'red',
    Vendor: 'purple',
    Consignee: 'pink',
    Broker: 'orange',
};
export const renderItem = (item, isHiglighted) => {
    const unauthorized = (item.type === 'Carrier' || item.type === 'Driver') && !item.authorized;
    const color = unauthorized ? roleStyles.Unauthorized : roleStyles[item._type];
    const text = unauthorized ? 'Unauthorized' : item._type;
    const name = item.type === 'Consignee'
        ? unescapeHTML(item.company_name)
        : unescapeHTML(item.name);
    const carrier = unescapeHTML(item.carrier);
    return (React.createElement(DropdownItem, { isHiglighted: isHiglighted, key: item.value, className: "list-group-item" },
        React.createElement(Translation, null, (t, { i18n }) => (React.createElement("div", { className: "flex -mx-4" },
            React.createElement("div", { className: "px-4 w-36" },
                React.createElement(Badge, { rounded: true, color: color, className: "label" }, t(sluggify(text)))),
            React.createElement("div", { className: "w-1/4 px-4" },
                React.createElement("span", { className: "font-bold searchName" }, name),
                item.carrier && (React.createElement("div", null,
                    React.createElement("span", { className: "italic text-grey" }, carrier)))),
            item.is_broker && (React.createElement("div", { className: "w-36 px-4" },
                React.createElement(Badge, { rounded: true, color: roleStyles.Broker, className: "label" }, t('BROKER')))),
            item._type !== 'Driver' && (React.createElement("div", { className: "w-1/2 px-4" },
                React.createElement("span", { className: "text-xs text-grey", id: "user-email" }, item.email))))))));
};
